import React from 'react'
import { Text4, Text4_5, Text5, Text6, Text7 } from '../Common'
import { SwitchContainer, SwitchWrapper } from './styles'

const Switch = () => {
    const [isLeft , setIsLeft] = React.useState(true);
    return (
      <SwitchWrapper>
        <div
          onClick={() => {
            setIsLeft(true);
          }}
        >
          <Text4_5
            color={"white"}
            style={{ zIndex: 10, margin: "0px auto" }}
            weight={800}
          >
            Monthly
          </Text4_5>
        </div>
        <div
          onClick={() => {
            setIsLeft(false);
          }}
        >
          <Text4_5
            color={"white"}
            style={{ zIndex: 10, margin: "0px auto" }}
            weight={800}
          >
            Annualy
          </Text4_5>
          <Text7 color={"white"} style={{ zIndex: 10, margin: "0px auto" }}>
            2 months free
          </Text7>
        </div>
        <SwitchContainer isLeft={isLeft} />
      </SwitchWrapper>
    );
}

export default Switch
